const mutations = {
    aa() {

    },
    setMeetingInfo(state,parame){
        window.console.log(`setMeetingInfo：${parame}`);
        window.console.log(parame);
        state.meetingInfo = parame;
    }
};

export default mutations;